module.exports = __webpack_public_path__ + "assets/images/icon-success--xs.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/icon-success--xs.svg
 ** module id = 155
 ** module chunks = 0
 **/